import { forwardRef } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
//
import { StyledLabel } from './Label.styles';
import { LabelProps } from './types';

// ----------------------------------------------------------------------

export const Label = forwardRef<HTMLSpanElement, LabelProps>(
    (
        {
            children,
            color = 'default',
            colorVariant = 'light',
            variant = 'soft',
            startIcon,
            endIcon,
            sx,
            ...other
        },
        ref
    ) => {
        const theme = useTheme();

        const iconStyle = {
            width: 16,
            height: 16,
            '& svg, img': { width: 1, height: 1, objectFit: 'cover' },
        };

        return (
            <StyledLabel
                ref={ref}
                component="span"
                customState={{ color, variant, colorVariant }}
                sx={{
                    ...(startIcon && { paddingInlineStart: 0.75 }),
                    ...(endIcon && { paddingInlineEnd: 0.75 }),
                    ...sx,
                }}
                theme={theme}
                {...other}
            >
                {startIcon && (
                    <Box sx={{ marginInlineEnd: 0.75, ...iconStyle }}>
                        {startIcon}
                    </Box>
                )}

                {children}

                {endIcon && (
                    <Box sx={{ marginInlineStart: 0.75, ...iconStyle }}>
                        {endIcon}
                    </Box>
                )}
            </StyledLabel>
        );
    }
);
